export const AdmisionUrgencyCta = () => (
  <section className="py-20 bg-[#d3b163]" data-testid="urgency-cta">
    <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12 text-center">
      <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
        Espacios limitados disponibles
      </h2>
      <p className="text-lg text-white/95 mb-8">
        No esperes más. Solicita orientación hoy mismo y asegura el futuro académico de tu hijo.
      </p>
      <a
        href="tel:+17873625354"
        className="inline-block bg-white text-[#d3b163] px-8 py-4 rounded-full font-semibold hover:bg-stone-50 transition-all active:scale-95"
      >
        Llámanos: (787) 362-5354
      </a>
    </div>
  </section>
);
